module.exports = __webpack_public_path__ + "img/block-375.de730faa.jpg";